module.exports = __webpack_public_path__ + "static/media/bars.ea766e41.svg";